<template>
  <div>
    <b-modal id="delete-user-group" hide-footer title="Delete User">
      <h5>
        Are you sure you want to remove {{ selectedUser }} from the group?
      </h5>
      <div
        class="d-flex justify-content-center align-items-center"
        style="gap:10px"
      >
        <b-button
          style="flex:1"
          variant="outline-danger"
          @click="$bvModal.hide('delete-user-group')"
        >
          No
        </b-button>
        <b-button
          style="flex:1"
          variant="primary"
          :disabled="loadingDeleteBtn"
          @click="deleteUserFromGroup"
        >
          <b-spinner v-if="loadingDeleteBtn" small />
          <span v-else>Yes</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, BSpinner } from "bootstrap-vue";
import { ref } from "@vue/composition-api";

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
  },
  props: {
    selectedUser: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const loadingDeleteBtn = ref(false);
    const groupID = ctx.root.$route.params.id || ctx.root.$route.query.id;

    const deleteUserFromGroup = async () => {
      try {
        loadingDeleteBtn.value = true;
        await ctx.root.$store.dispatch("groups/removeUserFromGroup", {
          body: {
            users: [props.selectedUser],
          },
          groupID: groupID,
        });
        ctx.root.$bvModal.hide("delete-user-group");
        ctx.emit("delete");
      } catch (error) {
        console.log(error);
      } finally {
        loadingDeleteBtn.value = false;
      }
    };

    return {
      deleteUserFromGroup,
      loadingDeleteBtn,
    };
  },
};
</script>
